const products = [
    {
        id: 1,
        name: "Mix de Frutos Rojos",
        imgPath: "/assets/products/mixto.jpg",
        price: 520,
        desc: "Nuestro mix de frutos rojos incluye arándanos, moras y frambuesas!"
    },

    {
        id: 2,
        name: "Frutillas",
        imgPath: "/assets/products/frutilla.jpg",
        price: 280,
        desc: "Enteras, despalilladas y congeladas. Cada una está separada del resto y se pueden fraccionar. Ideales para tus smoothies, y para usar de relleno en algún budín o torta."
    },

    {
        id: 3,
        name: "Mango",
        imgPath: "/assets/products/mango.jpg",
        price: 470,
        desc: "Pulpa de mango cortada en cubos congelada. Cada cubo de mango está separado del resto, lo que lo hace ideal para fraccionar; se puede usar lo que se vaya a consumir y el resto se vuelve a guardar en el freezer."
    },

    {
        id: 4,
        name: "Arándanos",
        imgPath: "/assets/products/arandanos.jpg",
        price: 430,
        desc: "Enteros, lavados y congelados, listos para consumir. Variedad Rabbiteye. Nuestros arándanos tienen un aroma cítrico y suave. Son muy gustosos y al descongelar la textura de su interior es jugosa. Incluso si se comen estando congelados su sabor es exquisito."
    },

    {
        id: 5,
        name: "Frambuesas",
        imgPath: "/assets/products/frambuesa.jpg",
        price: 560,
        desc: "Frambuesas enteras y congeladas. Cada frambuesa fue congelada por separado, lo que hace que no se peguen en “bloque”. Están al natural, sin ningún agregado. Su aroma es fresco y puro. Tienen un gusto cítrico y muy refrescante."
    },

    {
        id: 6,
        name: "Durazno",
        imgPath: "/assets/products/durazno.jpg",
        price: 450,
        desc: "Pelados, cortados en mitades y congelados. Nuestros duraznos tienen gusto a almíbar suave y dulzón. Al descongelar son pulposos, delicados y jugosos. Están al natural y no tienen agregados."
    },

    {
        id: 7,
        name: "Ananá",
        imgPath: "/assets/products/anana.jpg",
        price: 420,
        desc: "Pulpa de ananá cortada en cubos congelada. Cada cubo de ananá está separado del resto, lo que lo hace ideal para fraccionar; utilizas lo que vayas a consumir y el resto se vuelve a guardar en el freezer."
    },

    {
        id: 8,
        name: "Palta",
        imgPath: "/assets/products/palta.jpg",
        price: 680,
        desc: "La textura de nuestra palta luego de descongelar es igual a la de la palta fresca. Queda tierna, en su mejor punto de maduración y no libera agua."
    },
];


export default products;